var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "toggle-button",
      class: { active: _vm.isActive },
      attrs: {
        type: "button",
        disabled: _vm.isDisabled,
        "aria-label": _vm.label,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "span",
        { staticClass: "icon-wrapper" },
        [
          _c("SvgIcon", {
            attrs: { icon: _vm.icon, "is-filled": _vm.iconFilled },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.label))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }